<template>
  <div id="home" style="margin-top:40px">
    <b-container>
      <div id="home_banner">
        <div id="home_banner_text">
          <h1>Welcome to the CHIME/FRB Public Database</h1>
        </div>
      </div>
    </b-container>
    <b-container class="homepage-footer">
      <b-row align-v="center" class="text-center">
        <b-col cols="2"> <b-img :src="require('../assets/mcgill_logo.png')" fluid> </b-img> </b-col>
        <b-col cols="2"> <b-img :src="require('../assets/uoft_logo.png')" fluid> </b-img> </b-col>
        <b-col cols="2"> <b-img :src="require('../assets/ubc_logo.png')" fluid> </b-img> </b-col>
        <b-col cols="1"> <b-img :src="require('../assets/drao_logo.png')" fluid> </b-img> </b-col>
        <b-col cols="1"> <b-img :src="require('../assets//pi_logo.png')" fluid> </b-img> </b-col>
        <b-col cols="1"> <b-img :src="require('../assets//mit_logo.png')" fluid> </b-img> </b-col>
        <b-col cols="3">
          <b-row align-v="center">
            <b-col cols="3"> <b-img :src="require('../assets/nrao_logo.png')" fluid> </b-img> </b-col>
            <b-col cols="9"> <b-img :src="require('../assets/wvu_logo.png')" fluid> </b-img> </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
export default {
  name: 'home',
  props: {
    msg: String
  },
}
</script>

<style>
  #home_banner {
    padding: 40px;
    text-align: center;
    background: url(../assets/FRBs_4rows.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: auto;
    margin-bottom: 0px;
    background-size: 100% 100%;
    background-position: center center;
    opacity: 0.95;
  }
  #home_banner_text {
    padding: 100px;
    border-radius: 20px;
    background-color: rgba(60, 60, 60, 0.0);
  }
  #home_banner_text h1{
    padding: 20px;
    border-radius: 20px;
    background-color: rgba(60, 60, 60, 0.95);
    color: white;
    width: 105%;
  }
</style>
